import { Button, IconErrorCircleSolid } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { EnrollmentHYCSLayout } from '@egw/layouts'
import { type FC } from 'react'
import { useNavigate } from 'react-router'

export const UnableVerifyPage: FC = () => {
  const { t } = useTranslation('features-enrollment')
  const navigate = useNavigate()

  const onSubmit = (): void => {
    void navigate(WEALTH_ROUTES.SIGN_IN.path)
  }

  return (
    <EnrollmentHYCSLayout title={t('generic.unable_to_verify.page_title')}>
      <div className="egw-container-re-entry w-full">
        <IconErrorCircleSolid className="mb-sm mt-3xl" />
        <h2 className="typo-primary-2xl-light text-text-header-error mb-md">{t('generic.unable_to_verify.title')}</h2>
        <p className="text-text-body typo-primary-base">{t('generic.unable_to_verify.description')}</p>

        <div className="flex-1 md:hidden" />

        <Button type="submit" className="w-full md:w-min mt-xl" onClick={onSubmit} testId="primaryAction_button">
          {t('generic.fatal_error_cta')}
        </Button>
      </div>
    </EnrollmentHYCSLayout>
  )
}
